// src/RoutesWithTracking.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import useAnalytics from "./components/useAnalytics/useAnalytics";

import Contact from "./Pages/Contact/ContactPage";
import TaxiSinglePage from "./Pages/TaxiSinglePage/TaxiSinglePage";
import AllTaxiYad2ForSalepage from "./Pages/AllTaxiYad2ForSalepage/AllTaxiYad2ForSalepage";
import LoginPage from "./Pages/Login/LoginPage";
import DashboardPage from "./Pages/Dashboard/DashboardPage";
import AddTaxiForSaleDashPage from "./Pages/AddTaxiForSaleDash/AddTaxiForSaleDashPage";
import ProtectedRoute from "./ProtectedRoute";
import AddTasksForBuyTaxiDash from "./Pages/AddTasksForBuyTaxiDash/AddTasksForBuyTaxiDash";
import AllTaxiTable from "./Pages/AllTaxiTabledash/AllTaxiTabledash";
import TaxiAtFixPage from "./Pages/TaxiAtFixPage/TaxiAtFixPage";
import NewTaxiPage from "./Pages/NewTaxiPage/NewTaxiPage";
import NumberTaxiForRentPage from "./Pages/NumberTaxiForRentPage/NumberTaxiForRentPage";
import NumberTaxiForSellPage from "./Pages/NumberTaxiForSellPage/NumberTaxiForSellPage";
import BlogAndMagazineForTaxiPage from "./Pages/BlogAndMagazineForTaxiPage/BlogAndMagazineForTaxiPage";
import InsuranceTaxiPage from "./Pages/InsuranceTaxiPage/InsuranceTaxiPage";
import TermsPage from "./Pages/TermsPage/TermsPage";
import ContactPageDash from "./Pages/ContactPageDash/ContactPageDash";
import AccessibilityPolicypage from "./Pages/AccessibilityPolicypage/AccessibilityPolicypage";
import NumberTaxiDashPage from "./Pages/NumberTaxiDashPage/NumberTaxiDashPage";
import FacebookAutoControl from "./Pages/FaceBookAutoDash/FaceBookAutoDash";
import BlogsDash from "./Pages/BlogsDashPage/BlogsDashPage";
import BlogsTemplatePage from "./Pages/BlogsTemplatePage/BlogsTemplatePage";
import NumberTaxiForSaleOrRentPage from "./Pages/NumberTaxiForSaleOrRentPage/NumberTaxiForSaleOrRentPage";
import SingaleProductTemplate from "./Pages/Products/SingaleProductTemplate/SingaleProductTemplate";
import CashOutPage from "./Pages/CashOutPage/CashOutPage";
import AllProductsPage from "./Pages/AllProductsPage/AllProductsPage";
import CosumtersProductsDashPage from "./Pages/CosumtersProductsDashPage/CosumtersProductsDashPage";

const RoutesWithTracking = () => {
  useAnalytics(); // מעקב כאן, בתוך ה-router

  return (
    <Routes>
      <Route path="/" element={<AllProductsPage />} />
      <Route path="/contactus" element={<Contact />} />
      <Route path="/taxi/:id" element={<TaxiSinglePage />} />
      <Route path="/AllTaxiYad2ForSalepage" element={<AllTaxiYad2ForSalepage />} />
      <Route path="/moralandamirlo" element={<LoginPage />} />
      <Route path="/taxiAtfix" element={<TaxiAtFixPage />} />
      <Route path="/NewTaxi" element={<NewTaxiPage />} />
      <Route path="/NumberTaxiForRent" element={<NumberTaxiForRentPage />} />
      <Route path="/NumberTaxiForSell" element={<NumberTaxiForSellPage />} />
      <Route path="/BlogAndMagazine" element={<BlogAndMagazineForTaxiPage />} />
      <Route path="/blog/:id" element={<BlogsTemplatePage />} />
      <Route path="/product/:id" element={<SingaleProductTemplate />} />
      <Route path="/InsuranceTaxi" element={<InsuranceTaxiPage />} />
      <Route path="/Terms" element={<TermsPage />} />
      <Route path="/Products" element={<AllProductsPage />} />
      <Route path="/cashout" element={<CashOutPage />} />
      <Route path="/NumberTaxiForSaleOrRent/:id" element={<NumberTaxiForSaleOrRentPage />} />
      <Route path="/AccessibilityPolicypage" element={<AccessibilityPolicypage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/dashboard/CosumtersProductsDashPage" element={<ProtectedRoute><CosumtersProductsDashPage /></ProtectedRoute>} />
      <Route path="/dashboard/AddTaxiForSaleDashPage" element={<ProtectedRoute><AddTaxiForSaleDashPage /></ProtectedRoute>} />
      <Route path="/dashboard/AddTasksForBuyTaxiDash" element={<ProtectedRoute><AddTasksForBuyTaxiDash /></ProtectedRoute>} />
      <Route path="/dashboard/AllTaxiTableDash" element={<ProtectedRoute><AllTaxiTable /></ProtectedRoute>} />
      <Route path="/dashboard/ContactPageDash" element={<ProtectedRoute><ContactPageDash /></ProtectedRoute>} />
      <Route path="/dashboard/NumberTaxiDashPage" element={<ProtectedRoute><NumberTaxiDashPage /></ProtectedRoute>} />
      <Route path="/dashboard/FacebookAutoControl" element={<ProtectedRoute><FacebookAutoControl /></ProtectedRoute>} />
      <Route path="/dashboard/BlogsDash" element={<ProtectedRoute><BlogsDash /></ProtectedRoute>} />
    </Routes>
  );
};

export default RoutesWithTracking;
